import React, { useEffect } from "react";
import FrameMessagesAPI from '../../../utils/FrameMessagesAPI';
import RouteFrameCollectionManagerUtils from '../utils/RouteFrameCollectionManagerUtils';
import ThirdPartyBrowserLocationUtils from '../../ThirdPartyIntegration/utils/ThirdPartyBrowserLocationUtils';
const FrameCollectionComponent = ({ children, history, }) => {
    useEffect(() => {
        FrameMessagesAPI.startListening();
        FrameMessagesAPI.registerFrame('parent', window.parent);
        FrameMessagesAPI.registerMessageProcessor('iframe_location_change', (message) => {
            RouteFrameCollectionManagerUtils.locationChange(message, history);
        });
        FrameMessagesAPI.registerMessageProcessor('third_party_iframe_location_change', (message) => {
            ThirdPartyBrowserLocationUtils.updateBrowserLocationWithPushAndNoSectionChange(message.url, history, '*');
        });
        return () => {
            FrameMessagesAPI.stopListening();
        };
    }, []);
    return React.createElement(React.Fragment, null, children);
};
export default FrameCollectionComponent;
//# sourceMappingURL=FrameCollectionComponent.js.map